import SVGProps from "../../models/Svg";

const Vue = ({ size }: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M2 4L16 28L30 4H24.5L16 18.5L7.5 4H2Z"
        fill="#41B883"
      />
      <path
        d="M7.5 4L16 18.5L24.5 4H19.5L16.0653 10.0126L12.5 4H7.5Z"
        fill="#35495E"
      />
    </svg>
  );
};

export default Vue;
